import { Download } from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

type PdfDocumentDownloadButtonProps = {
    downloadUrl: string;
    buttonText: string;
    fileName: string;
    pdfGenerationError: boolean;
    isLoading: boolean;
}

export const PdfDocumentDownloadButton = ({ downloadUrl, buttonText, fileName, pdfGenerationError, isLoading }: PdfDocumentDownloadButtonProps) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {downloadUrl ? (
            <Button
                variant="outlined"
                size="small"
                startIcon={<Download />}
                component="a"
                href={downloadUrl}
                download={`${fileName}.pdf`}
            >
                {buttonText}.pdf
            </Button>
        ) : pdfGenerationError ? (
            <Typography color="error" variant="caption">
                Erro ao gerar documento.
            </Typography>
        ) : isLoading ? (
            <CircularProgress size={20} />
        ) : (
            null
        )}
    </Box>
    )
}